
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/>
    <h6 class="p-text-bold p-mt-5">Divergências</h6>
    <div class="p-formgroup-inline">
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarFalta" :binary="true"/>
            <label>Falta</label>
        </div>
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarFaltaMarcacao" :binary="true"/>
            <label>Falta de marcação</label>
        </div>
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarAtraso" :binary="true"/>
            <label>Atraso</label>
        </div>
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarSaidaAntecipada" :binary="true"/>
            <label>Saída antecipada</label>
        </div>
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarExcessoRefeicao" :binary="true"/>
            <label>Excesso no int. da refeição</label>
        </div>
        <div class="p-field-checkbox">
            <Checkbox v-model="selecionarInterjornada" :binary="true"/>
            <label>Interjornada</label>
        </div>
    </div>  
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <div class="p-d-flex p-jc-left">		
        
            <!-- <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3"
            @click="processarPdf" :disabled="bloquearEnivo"/>
            <Button icon="pi pi-file" class="p-ml-2" title="Exporta para arquivo XLS" 
            @click="processarXls" :disabled="bloquearEnivo"/> -->
            <SplitButton label="Gerar" class="p-mt-3 p-mr-2"  icon="pi pi-plus" :model="opcoesFormato" 
            :disabled="bloquearEnivo" appendTo="body"></SplitButton>
            <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizar"/>  
       
    </div>    
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {     
            bloquearEnivo: false,
            selecionarFalta: true,
            selecionarFaltaMarcacao: true,
            selecionarSaidaAntecipada: true,
            selecionarAtraso: true,
            selecionarInterjornada: true,
            selecionarExcessoRefeicao: true,
            dataInicio: new Date(),
            dataFinal: new Date(),
            opcoesFormato:[],
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),  
        /**
         * 
         */
        processarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {
                selecionarFalta: this.selecionarFalta,
                selecionarFaltaMarcacao: this.selecionarFaltaMarcacao,
                selecionarSaidaAntecipada: this.selecionarSaidaAntecipada,
                selecionarAtraso: this.selecionarAtraso,
                selecionarInterjornada: this.selecionarInterjornada,
                selecionarExcessoRefeicao: this.selecionarExcessoRefeicao,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                idsFuncionarios: idsFuncionarios,
                idsCentrosCustos: dados.idsCentrosCustos, 
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                todos: false,
                nomeDocumento: 'Divergências',
                nomeArquivo: 'Divergencias',
                servico: 'divergenciasPdf',
                tipoDocumento: 'pdf',
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.processar(requisicao)
            .then(resp => {     
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data);     
            })
            .catch(erro => {
                exibirMensagem(this, erro)
            });
        },
        processarXls() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {
                selecionarFalta: this.selecionarFalta,
                selecionarFaltaMarcacao: this.selecionarFaltaMarcacao,
                selecionarSaidaAntecipada: this.selecionarSaidaAntecipada,
                selecionarAtraso: this.selecionarAtraso,
                selecionarInterjornada: this.selecionarInterjornada,
                selecionarExcessoRefeicao: this.selecionarExcessoRefeicao,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                idsFuncionarios: idsFuncionarios,
                idsCentrosCustos: dados.idsCentrosCustos,    
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                todos: dados.todos,
                nomeDocumento: 'Divergências',
                nomeArquivo: 'Divergencias',
                servico: 'divergenciasXls',
                tipoDocumento: 'xls',
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }            
            this.relatorioService.processar(requisicao)
            .then(resp => {     
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data);           
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });           
        },
        /**
         * 
         */
         finalizar() {            
            this.bloquearEnivo = false;
        }, 
        /**
         * 
         */
        configurarOpcoes() {
            this.opcoesFormato = [
                {
                    label: 'Pdf',
                    icon: 'pi pi-file-pdf',
                    command: () => {
                        this.processarPdf();
                    }
                },          
                {
                    label: 'Excel',
                    icon: 'pi pi-file',
                    command: () => {
                        this.processarXls();
                    }
                },
            ];                
          },
        /**
         * 
         * @param data 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}
    },
    created() {
        this.configurarOpcoes();
        this.relatorioService = new RelatorioService();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>

</style>